export default __webpack_public_path__ + "static/media/chevron-down.c5c9cc0c.svg";